import { render, staticRenderFns } from "./MultibarChart.vue?vue&type=template&id=0cea1334&scoped=true&"
import script from "./MultibarChart.vue?vue&type=script&lang=js&"
export * from "./MultibarChart.vue?vue&type=script&lang=js&"
import style0 from "./MultibarChart.vue?vue&type=style&index=0&id=0cea1334&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea1334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
